import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelBrevoEvent } from "./panel-brevo-event";

export function BrevoActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelBrevoEvent />
    </PanelContainer>
  );
}
